import { useState } from "react";
import DynamicIcon from "./DynamicIcon";
import { Popover } from "@mui/material";

function RefreshButton({ onClick, message = "Recarregar página" }: { onClick?: () => void, message?: string }) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <div>
      <div
        className="cursor-pointer"
        onClick={onClick}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}>
        <DynamicIcon nameIcon="RefreshRounded" size={30} className="text-primary-green" />
      </div>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <p className="p-3 text-sm">{message}</p>
      </Popover>
    </div>
  );
}

export default RefreshButton;